import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import CategoriesList from './pages/CategoriesList';
import MenuItems from './pages/MenuItems';
import Chart from './pages/Chart';
import ChartVocalInteface from './pages/ChartVocalInteface';
import CategoriesListVocal from './pages/CategoriesListVocal';

function App() {
  return (
    <> 
      <Switch>
        <Route exact path='/cardapio/:menu/categories' component={ CategoriesList } />
        <Route exact path='/cardapio/:menu/categoriesvocal' component={ CategoriesListVocal } />
        <Route exact path='/cardapio/:menu/categories/:category' component={ MenuItems } />
        <Route exact path='/cardapio/:menu?' component={ Home }/>
        <Route exact path='/cardapio/:menu/chart' component={ Chart }/>
        <Route exact path='/cardapio/:menu/chartvocal' component={ ChartVocalInteface }/>
      </Switch>    
    </>
  );
}

export default App;
